type QueryValue = string | (string | null)[] | null | undefined;

// The tracking id comes from the caller when it already picked one, else from
// the url's `tId` (or older `trackingId`). query-string can return arrays/null
// for repeated params; ids are single values.
export function trackingResolveTrackingId(
  overrideTrackingId: string | undefined,
  query: { tId?: QueryValue; trackingId?: QueryValue },
): string | undefined {
  if (overrideTrackingId !== undefined) {
    return overrideTrackingId;
  }
  const trackingIdParam = query.tId ?? query.trackingId;
  return typeof trackingIdParam === "string" ? trackingIdParam : undefined;
}
